(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details-teams.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details-teams.js');
"use strict";

const {
  StepIndicatorResult
} = svs.components.marketplaceShared.stepIndicator;
const {
  Initials
} = svs.components.marketplaceShared.initials;
const CompetitionDetailsTeams = _ref => {
  let {
    drawResults = []
  } = _ref;
  const players = {};
  drawResults.forEach(draw => {
    if (draw) {
      const highestScore = draw.contributions.reduce((acc, prev) => acc > prev.correctCount ? acc : prev.correctCount, 0);
      draw.contributions.forEach(playerDraw => {
        if (!players[playerDraw.uid]) {
          players[playerDraw.uid] = {
            uid: playerDraw.uid,
            isAnonymous: playerDraw.isAnonymous,
            firstname: playerDraw.firstname,
            lastname: playerDraw.lastname,
            location: playerDraw.location,
            drawResults: {}
          };
        }
        players[playerDraw.uid].drawResults[draw.drawNumber] = {
          drawNumber: draw.drawNumber,
          correctCount: playerDraw.correctCount,
          isContributing: playerDraw.isContributing && draw.isContributing,
          hasPlayed: playerDraw.hasPlayed,
          hasHighestScore: playerDraw.correctCount === highestScore
        };
      });
    }
  });
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "competition-drawnum-team"
  }, drawResults.map((result, i) => {
    const key = result ? "".concat(i, "_").concat(result.drawNumber) : i;
    return React.createElement("div", {
      className: "drawnum-team-item",
      key: key
    }, React.createElement("div", {
      className: "align-center drawnum-team-item-draw"
    }, "Omg. ".concat(i + 1, " ")), React.createElement("div", {
      className: "align-center drawnum-team-item-corrects"
    }, "".concat(result.correctCount, "p")));
  })), React.createElement("div", {
    className: "competition-details-team-result"
  }, Object.values(players).map(player => React.createElement("div", {
    className: "competition-details-team data-hj-suppress",
    key: player.uid
  }, React.createElement(Initials, {
    firstname: player.firstname,
    isAnonymous: player.isAnonymous,
    isSimpleDiv: true,
    lastname: player.lastname
  }), React.createElement(StepIndicatorResult, {
    drawResults: Object.values(player.drawResults),
    isTeamDetails: true
  })))));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.details.CompetitionDetailsTeams', CompetitionDetailsTeams);

 })(window);